import React, {useState, useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { Form, Button, Row, Col, Tabs, Tab, Card, Spinner, Alert, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faPlus, faGripVertical, faChevronUp, faChevronDown, faCamera, faPaperclip, faPaintbrush, faFont, faHashtag,
	faSquareCheck, faListCheck, faGear, faHeading, faUsers, faCheck, faBarcode } from '@fortawesome/free-solid-svg-icons'
import { faCalendar, faClock, faFolder, faMap } from '@fortawesome/free-regular-svg-icons'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import TextareaAutosize from 'react-textarea-autosize'
import { v4 as uuidv4 } from 'uuid'
import { authService, documentationService, templateService, suggestionListService, licenseService, photoService,
	fileService, documentationTaskService, referencePhotoService, customerService } from '../../../_services'
import Select from 'react-select'
import { history } from '../../../_helpers'
import { alertActions } from '../../../_actions'
import { useDispatch, useSelector } from 'react-redux'
import ScrollUpButton from '../../scrollupbutton.component'
import moment from 'moment'
import { SERVER_URL } from '../../../config'
import MapButton from './mapbutton'
import MapTask from './maptask'
import { GoogleMap, Marker } from '@react-google-maps/api'

function DocumentationForm() {

	const [customers, setCustomers] = useState([])
	const [templates, setTemplates] = useState([])
	const [selectedTemplate, setSelectedTemplate] = useState(null)
	const [loadingTemplate, setLoadingTemplate] = useState(false)
	const [suggestionLists, setSuggestionLists] = useState([])
	const [licenses, setLicenses] = useState([])
	const [selectedLicense, setSelectedLicense] = useState(null)
	const [documentation, setDocumentation] = useState(null)
	const [name, setName] = useState('')
	const [photos, setPhotos] = useState([])
	const [files, setFiles] = useState([])
	const [referencePhotos, setReferencePhotos] = useState([])
	const [validated, setValidated] = useState(false)
	const [saving, setSaving] = useState(false)
	const [documentationStatus, setDocumentationStatus] = useState('')
	const [showProgressModal, setShowProgressModal] = useState(false)
	const [documentationProgress, setDocumentationProgress] = useState(0)
	const [photoProgress, setPhotoProgress] = useState(0)
	const [fileProgress, setFileProgress] = useState(0)
	const [showAddContactPersonModal, setShowAddContactPersonModal] = useState(false)
	const [addContactPersonSuggestionList, setAddContactPersonSuggestionList] = useState(null)
	const [addContactPersonValues, setAddContactPersonValues] = useState([])
	const [loadingPredefinedAnswers, setLoadingPredefinedAnswers] = useState(false)
	const {t} = useTranslation('common')
    const dispatch = useDispatch()
    const alert = useSelector(state => state.alert)
    const [map, setMap] = React.useState(null)
    const mapContainerStyle = {
		width: '100%',
		height: '400px'
    }

    useEffect(() => {
        licenseService.list(100).then(data => {
            setLicenses(data)
            if (data.length == 1) {
                setSelectedLicense(data[0])
            }
        })
		templateService.list(10000).then(data => {
            setTemplates(data)
        })
        suggestionListService.list(1000).then(data => {
            setSuggestionLists(data)
        })
        referencePhotoService.list(1000).then(data => {
            setReferencePhotos(data)
        })
        if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
			customerService.list().then(data => {
                setCustomers(data)
            })
        }
    }, [])

    const handleSubmit = (event) => {
        console.log('handleSubmit')

	    event.preventDefault()

	    const form = event.currentTarget
	    const documentationStatus = event.nativeEvent.submitter.value
	    var complete = documentationStatus == 'completed'

	    if (complete && form.checkValidity() === false) {
	        event.stopPropagation()
	        setValidated(true)
	    } else {
	        setDocumentationStatus(documentationStatus)
	        handleConfirm(documentation, documentationStatus)
	        setValidated(false)
	    }
    }

    async function handleConfirm(documentation, documentationStatus) {
        setSaving(true)

        setShowProgressModal(true)
        setDocumentationProgress(0)
        setPhotoProgress(0)
        setFileProgress(0)

        const licenseCode = selectedLicense.licenseCode

		documentation.name = name
        documentation.numberOfPhotos = photos.length

        var result = await documentationService.saveWithLicenseCode(documentation, licenseCode)
        console.log(result)

        setDocumentationProgress(1)

		for (let i = 0; i < photos.length; i++) {
			const photo = photos[i]
            const photoResult = await photoService.saveWithLicenseCode(photo, licenseCode)
            console.log(photoResult)
            const uploadResult = await photoService.upload({id: photo.id, customerId: documentation.customerId, data: photo.data}, photo.id, licenseCode)
            console.log(uploadResult)

            setPhotoProgress(i + 1)
		}

		for (let i = 0; i < files.length; i++) {
			const file = files[i]
            const fileResult = await fileService.saveWithLicenseCode(file, licenseCode)
            console.log(fileResult)
            const uploadResult = await fileService.upload({id: file.id, customerId: documentation.customerId, data: file.data}, file.id, licenseCode)
            console.log(uploadResult)

            setFileProgress(i + 1)
		}

		var creator = authService.getCurrentUser().username

		if (documentationStatus == 'completed') {
			result = await documentationService.completeWithLicenseCode(documentation.id, licenseCode, creator)
	        console.log(result)
        } else if (documentationStatus == 'paused') {
			result = await documentationService.pauseWithLicenseCode(documentation.id, licenseCode, creator)
	        console.log(result)
        } else if (documentationStatus == 'draft') {
			result = await documentationService.saveDraftWithLicenseCode(documentation.id, licenseCode, creator)
	        console.log(result)
        }

		setSaving(false)
		setShowProgressModal(false)
        history.replace("/documentation/details/" + documentation.id)
        dispatch(alertActions.success(t('alerts.createsuccessful')))
    }

    const handleNameChange = e => {
        setName(e.target.value)
    }

    const handleAnswerChange = (e, task) => {
        console.log('handleAnswerChange')

	    const target = e.target
	    const name = target.name
	    var value = target.value
	    if (task.type == 'MULTI_CHOICE' || task.type == 'MULTI_CHOICE_SUGGESTION') {
			var answers = task.answer ? task.answer.split(';') : []

			if (target.checked) {
				answers.push(target.name)
			} else {
				answers = answers.filter(answer => answer != target.name)
			}

			value = answers.join(';')
	    } else if (task.type == 'DATE_RANGE') {
	        var split = task.answer.split(';')
	        if (target.name == 'date1') {
	            value = value + ";" + split[1]
	        } else if (target.name == 'date2') {
	            value = split[0] + ";" + value
	        }
	    } else if (task.type == 'DATE_TIME') {
	        var split = task.answer.split(' ')
	        if (target.name == 'date') {
	            value = value + " " + split[1]
	        } else if (target.name == 'time') {
	            value = split[0] + " " + value
	        }
	    } else if (task.type == 'CONTACT_PERSONS') {
	        var split = task.answer.split('\n')
	        if (split.includes(value)) {
	            split = split.filter(answer => answer != value)
	        } else {
	            split.push(value)
	        }
	        value = split.join("\n")
	    } else if (task.type == 'CHECKBOX') {
	        if (target.checked) {
	            value = task.options
	        } else {
	            value = ""
	        }
	    } else if (target.type === 'checkbox') {
	        value = target.checked
	    }

	    task.answer = value

	    if (!task.events.some(event => event.type == 'UPDATED')) {
	        var documentationTaskEvent = {
                id: uuidv4(),
                customerId: task.customerId,
                documentationTask: task.id,
                type: 'UPDATED',
                creator: authService.getCurrentUser().username,
                dateCreated: moment().format("YYYY-MM-DD[T]HH:mm:ssZ")
            }
            task.events.push(documentationTaskEvent)
	    } else {
	        task.events.filter(event => event.type == 'UPDATED').forEach(event => {
	            event.dateCreated = moment().format("YYYY-MM-DD[T]HH:mm:ssZ")
	        })
	    }

	    setDocumentation( prevState => ({
	        ...prevState,
	        tasks: prevState.tasks
		}))
	}

	const handlePhotoComment = (e, photo) => {
		photo.comment = e.target.value

		var newPhotos = [...photos]
		setPhotos(newPhotos)
	}

	const handleFileChange = (e, task) => {
        console.log('handleFileChange ' + task.name + ' ' + task.id)

        let targetFiles = e.target.files

        var promises = []

        var photoIndex = photos.filter(photo => photo.documentationTask == task.id).length + 1

        Array.from(targetFiles).forEach((targetFile, targetFileIndex) => {
            console.log(targetFile)

            let promise = new Promise((resolve, reject) => {
                let fileReader = new FileReader()
                fileReader.onload = function() {
                    let binaryString = fileReader.result
                    let hexString = btoa(binaryString)

                    if (task.type == "PHOTO" || task.type == "DRAWING") {
                        var index = photoIndex + targetFileIndex
	                    var photoName = task.name + "_" + (index < 10 ? '0' : '') + index

	                    var photo = {
				            id: uuidv4(),
				            customerId: documentation.customerId,
				            documentationTask: task.id,
				            documentation: documentation.id,
				            name: photoName,
				            comment: '',
				            creator: documentation.creator,
				            lat: 1000,
				            lng: 1000,
				            imported: true,
				            dateCreated: moment().format("YYYY-MM-DD[T]HH:mm:ssZ"),
				            data: hexString
				        }

				        resolve(photo)
                    } else if (task.type == "FILE") {
                        var file = {
				            id: uuidv4(),
				            customerId: documentation.customerId,
				            documentationTask: task.id,
				            documentation: documentation.id,
				            name: targetFile.name,
				            creator: documentation.creator,
				            type: targetFile.type,
				            imported: true,
				            dateCreated: moment().format("YYYY-MM-DD[T]HH:mm:ssZ"),
				            data: hexString
				        }

				        resolve(file)
                    }
                }

                fileReader.onerror = function() {
                    reject(fileReader)
                }

                fileReader.readAsBinaryString(targetFile)
            })
            promises.push(promise)
        })

        Promise.all(promises).then(values => {
            if (task.type == "PHOTO" || task.type == "DRAWING") {
	            var newPhotos = [...photos]
	            values.forEach(value => {
	                newPhotos.push(value)
	            })
	            setPhotos(newPhotos)
            } else if (task.type == "FILE") {
                var newFiles = [...files]
	            values.forEach(value => {
	                newFiles.push(value)
	            })
	            setFiles(newFiles)
            }
        })
    }

    const removePhoto = (e, photo) => {
        e.preventDefault()

		var newPhotos = photos.filter(p => p.id != photo.id)
		var remainingPhotos = newPhotos.filter(p => p.documentationTask == photo.documentationTask)
		if (remainingPhotos.length > 0) {
			var task = documentation.tasks.find(task => task.id == photo.documentationTask)
			if (task) {
				var index = 1
				remainingPhotos.forEach(remainingPhoto => {
					remainingPhoto.name = task.name + "_" + (index < 10 ? '0' : '') + index
					index++
				})
			}
		}
		setPhotos(newPhotos)
    }

    const removeFile = (e, file) => {
        e.preventDefault()

		var newFiles = files.filter(f => f.id != file.id)
		setFiles(newFiles)
    }

    const handleLicenseChange = (license) => {
        setSelectedLicense(license)
        setSelectedTemplate(null)
        setDocumentation(null)
        setPhotos([])
        setFiles([])
        setValidated(false)
    }

    const handleTemplateChange = (template) => {
        setLoadingTemplate(true)
        setSelectedTemplate(null)
        setPhotos([])
        setFiles([])
        setValidated(false)

        templateService.get(template.id).then(template => {
            setSelectedTemplate(template)

	        var documentation = {
	            id: uuidv4(),
	            customerId: template.customerId,
	            templateId: template.id,
	            name: "",
	            creator: authService.getCurrentUser().username,
	            phoneModel: "N/A",
	            osVersion: navigator.oscpu,
	            appVersion: "Portal",
	            deviceId: "N/A",
	            numberOfPhotos: 0,
	            deleteAutomatically: template.deleteAutomatically,
	            deleteTimeLimit: template.deleteTimeLimit,
	            exportAutomatically: template.exportAutomatically,
	            dateCreated: moment().format("YYYY-MM-DD[T]HH:mm:ssZ"),
	            templateLastUpdated: template.lastUpdated,
	            tasks: []
	        }

	        template.tasks.forEach(templateTask => {
	            var task = {
	                id: uuidv4(),
	                customerId: template.customerId,
	                templateTaskId: templateTask.id,
	                documentation: documentation.id,
	                parent: templateTask.parent,
	                name: templateTask.name,
	                key: templateTask.key,
	                description: templateTask.description,
	                type: templateTask.type,
	                options: templateTask.options,
	                answer: "",
	                required: templateTask.required,
	                position: templateTask.position,
	                level: templateTask.level,
	                params: templateTask.params,
	                preconditions: [],
	                events: [],
	                dateCreated: moment().format("YYYY-MM-DD[T]HH:mm:ssZ"),
	                referencePhotos: templateTask.referencePhotos
	            }

	            if (task.type == 'TEXT' && task.params && task.params.defaultAnswer) {
	                task.answer = task.params.defaultAnswer
	            }

	            templateTask.preconditions.forEach(templatePrecondition => {
	                var precondition = {
	                    id: uuidv4(),
	                    customerId: template.customerId,
	                    task: task.id,
	                    type: templatePrecondition.type,
	                    params: templatePrecondition.params,
	                    dateCreated: moment().format("YYYY-MM-DD[T]HH:mm:ssZ")
	                }
	                task.preconditions.push(precondition)
	            })

	            var documentationTaskEvent = {
	                id: uuidv4(),
	                customerId: template.customerId,
	                documentationTask: task.id,
	                type: 'CREATED',
	                creator: authService.getCurrentUser().username,
	                dateCreated: moment().format("YYYY-MM-DD[T]HH:mm:ssZ")
	            }
	            task.events.push(documentationTaskEvent)

	            documentation.tasks.push(task)
	        })

	        documentation.tasks.forEach(task => {
	            if (task.parent) {
		            var parent = documentation.tasks.find(parent => parent.templateTaskId == task.parent)
		            if (parent) {
		                task.parent = parent.id
		            }
	            }
	            task.preconditions.forEach(precondition => {
	                if (precondition.params.TASK_ID) {
	                    var otherTask = documentation.tasks.find(otherTask => otherTask.templateTaskId == precondition.params.TASK_ID)
	                    if (otherTask) {
	                        precondition.params.TASK_ID = otherTask.id
	                    }
	                }
	            })
	        })

	        setDocumentation(documentation)

	        setLoadingTemplate(false)
        })
    }

    const getTaskCard = task => {
        if (!checkPreconditions(task)) {
            return <div key={task.id}></div>
        }
        return <Card key={task.id} style={{ marginBottom: 10, marginLeft: 40 * task.level }}>
            <Card.Header style={{ background: 'none' }}>
                { task.type == 'HEADER' &&
                    <>
	                    { (task.options == '1' || !task.options) &&
		                    <span style={{fontWeight: 'bold', fontSize: '0.9375rem'}}>
			                    {task.name}
			                </span>
		                }
		                { task.options == '2' &&
		                    <span style={{fontWeight: 'bold', fontSize: '1.3rem'}}>
			                    {task.name}
			                </span>
		                }
		                { task.options == '3' &&
		                    <span style={{fontWeight: 'bold', fontSize: '1.6rem'}}>
			                    {task.name}
			                </span>
		                }
		                { task.options == '4' &&
		                    <span style={{fontWeight: 'bold', fontSize: '2rem'}}>
			                    {task.name}
			                </span>
		                }
	                </>
                }
                { task.type != 'HEADER' &&
                    <>
                        {getTaskIcon(task)}
                         &nbsp;
	                    <span style={{fontWeight: 'normal'}}>
		                    {task.name}
		                </span>
	                </>
                }
                &nbsp;
                {task.required == 'YES' ? '*' : ''}
                { task.description &&
                    <div>
                        <i>{task.description}</i>
                    </div>
                }
                { task.referencePhotos.length > 0 &&
                    <div>
                        <div>
                            Referensfoton:
                        </div>
                        <Row>
	                        { task.referencePhotos.map(templateTaskReferencePhoto => {
	                            return <Col md="3" sm="12" key={templateTaskReferencePhoto.id} style={{paddingRight: 0}}>
		                            <a href={SERVER_URL + "/referencePhoto/download/" + templateTaskReferencePhoto.referencePhoto} target="_blank">
			                            <img
			                                src={SERVER_URL + "/referencePhoto/download/" + templateTaskReferencePhoto.referencePhoto}
			                                style={{width: "100%"}}
			                            />
		                            </a>
	                            </Col>
	                        })}
                        </Row>
                    </div>
                }
            </Card.Header>
            { task.type != 'HEADER' &&
	            <Card.Body>
	                { (task.type == 'PHOTO' || task.type == 'DRAWING') &&
	                    <>
	                        <Row>
								{ photos.filter(photo => photo.documentationTask == task.id).map(photo => {
									return <Col md="4" sm="12" key={photo.id} style={{paddingLeft: 5, paddingRight: 5}}>
										<div className="clearfix">
											<div className="float-left">
												{photo.name}
											</div>
											<div className="float-right">
												<a href="#" onClick={e => removePhoto(e, photo)} style={{color: 'red'}}>
													<FontAwesomeIcon icon={faTrash}/>
												</a>
											</div>
										</div>
										<img src={"data:image/png;base64, " + photo.data} style={{width: '100%'}}/>
										{ task.type == 'PHOTO' &&
											<Form.Control
								                placeholder={t('photo.columns.comment')}
								                name="text"
								                value={photo.comment}
								                onChange={e => handlePhotoComment(e, photo)}
								                maxLength="255"
								            />
							            }
									</Col>
								})}
							</Row>
							<Row>
								<Col>
				                    <Form.Control
				                        type="file"
				                        accept={"image/jpeg"}
				                        name="file"
				                        onChange={e => handleFileChange(e, task)}
				                        multiple
				                        style={{color: 'transparent'}}
				                    />
				                    { task.required == 'YES' && !photos.some(photo => photo.documentationTask == task.id) &&
				                        <>
				                            <Form.Check
					                            type="checkbox"
					                            name={task.id + "-photosrequired"}
					                            label=""
					                            checked={false}
					                            onChange={(e) => console.log(e)}
					                            required
					                            style={{visibility: 'hidden'}}
					                        />
					                        { validated &&
					                            <Alert variant="danger" style={{marginTop: '5px'}}>
								                    {t('documentation.nophotosselectederror')}
								                </Alert>
					                        }
				                        </>
				                    }
			                    </Col>
		                    </Row>
	                    </>
	                }
	                { task.type == 'FILE' &&
	                    <>
	                        { files.filter(file => file.documentationTask == task.id).map(file => {
								return <div key={file.id} className="clearfix">
									<div className="float-left">
										{file.name}
									</div>
									<div className="float-right">
										<a href="#" onClick={e => removeFile(e, file)} style={{color: 'red'}}>
											<FontAwesomeIcon icon={faTrash}/>
										</a>
									</div>
								</div>
							})}
		                    <Form.Control
		                        type="file"
		                        accept={task.options ? task.options.split(';').map(option => '.' + option).join(',') : ''}
		                        name="file"
		                        onChange={e => handleFileChange(e, task)}
		                        multiple
		                        style={{color: 'transparent'}}
		                    />
		                    { task.required == 'YES' && !files.some(file => file.documentationTask == task.id) &&
		                        <>
		                            <Form.Check
			                            type="checkbox"
			                            name={task.id + "-filesrequired"}
			                            label=""
			                            checked={false}
			                            onChange={(e) => console.log(e)}
			                            required
			                            style={{visibility: 'hidden'}}
			                        />
			                        { validated &&
			                            <Alert variant="danger" style={{marginTop: '5px'}}>
						                    {t('documentation.nofilesselectederror')}
						                </Alert>
			                        }
		                        </>
		                    }
	                    </>
	                }
	                { (task.type == 'TEXT' || task.type == 'ZEBRA_SCANNER') &&
	                    <Form.Control
			                placeholder={''}
			                name="text"
			                value={task.answer}
			                onChange={e => handleAnswerChange(e, task)}
			                required={task.required == 'YES'}
			                maxLength="2000"
			                as="textarea"
			                rows={3}
			            />
	                }
	                { task.type == 'CHECKBOX' &&
	                    <Form.Label>
	                        <Form.Check
	                            id={task.id + '-checkbox'}
	                            type="checkbox"
	                            name="check"
	                            label={task.options}
	                            checked={task.answer}
	                            onChange={(e) => handleAnswerChange(e, task)}
	                            required={task.required == 'YES'}
	                        />
	                    </Form.Label>
	                }
	                { task.type == 'SINGLE_CHOICE' &&
	                    <Form.Control
	                        required={task.required == 'YES'}
	                        as="select"
	                        name="answer"
	                        value={task.answer}
	                        onChange={e => handleAnswerChange(e, task)}
	                    >
	                        <option value="">Välj svar</option>
	                        { task.options.split(";").map(option => {
	                            return <option key={task.id + '-' + option} value={option}>{option}</option>
	                        })}
		                </Form.Control>
	                }
	                { task.type == 'SINGLE_CHOICE_SUGGESTION' &&
	                    <Form.Control
	                        required={task.required == 'YES'}
	                        as="select"
	                        name="answer"
	                        value={task.answer}
	                        onChange={e => handleAnswerChange(e, task)}
	                    >
	                        <option value="">Välj svar</option>
	                        { suggestionLists.find(suggestionList => suggestionList.id == task.options) &&
	                            <>
	                                { suggestionLists.find(suggestionList => suggestionList.id == task.options).suggestions.map(suggestion => {
			                            return <option key={task.id + '-' + suggestion.id} value={suggestion.text}>{suggestion.text}</option>
			                        })}
	                            </>
	                        }
		                </Form.Control>
	                }
	                { task.type == 'MULTI_CHOICE' &&
	                    <>
		                    { task.options.split(";").map(option => {
		                        return <div key={task.id + '-' + option}>
		                            <Form.Label>
				                        <Form.Check
				                            id={task.id + option}
				                            type="checkbox"
				                            name={option}
				                            label={option}
				                            checked={task.answer && task.answer.split(';').includes(option)}
				                            onChange={(e) => handleAnswerChange(e, task)}
				                            required={task.required == 'YES' && !task.answer}
				                            style={{ whiteSpace: 'pre-line' }}
				                        />
				                    </Form.Label>
			                    </div>
		                    })}
	                    </>
	                }
	                { task.type == 'MULTI_CHOICE_SUGGESTION' &&
		                <>
		                    { suggestionLists.find(suggestionList => suggestionList.id == task.options) &&
		                        <>
				                    { suggestionLists.find(suggestionList => suggestionList.id == task.options).suggestions.map(suggestion => {
				                        return <div key={task.id + '-' + suggestion.id}>
				                            <Form.Label>
						                        <Form.Check
						                            id={task.id + '-' + suggestion.id}
						                            type="checkbox"
						                            name={suggestion.text}
						                            label={suggestion.text}
						                            checked={task.answer && task.answer.split(';').includes(suggestion.text)}
						                            onChange={(e) => handleAnswerChange(e, task)}
						                            required={task.required == 'YES' && !task.answer}
						                        />
						                    </Form.Label>
					                    </div>
				                    })}
		                        </>
		                    }
	                    </>
	                }
	                { task.type == 'DATE' &&
						<Form.Group controlId="answer">
			                <Form.Control
			                    type="date"
			                    name="answer"
			                    value={task.answer || ''}
			                    onChange={(e) => handleAnswerChange(e, task)}
			                    required={task.required == 'YES'}
			                    style={{ width: 240 }}
			                />
			            </Form.Group>
					}
					{ task.type == 'DATE_RANGE' &&
						<Form.Group controlId="answer">
			                <Form.Control
			                    type="date"
			                    name="date1"
			                    value={task.answer ? task.answer.split(";")[0] : ''}
			                    onChange={(e) => handleAnswerChange(e, task)}
			                    required={task.required == 'YES'}
			                    max={task.answer ? task.answer.split(";")[1] : ''}
			                    style={{ marginBottom: 2, width: 240 }}
			                />
			                <Form.Control
			                    type="date"
			                    name="date2"
			                    value={task.answer ? task.answer.split(";")[1] : ''}
			                    onChange={(e) => handleAnswerChange(e, task)}
			                    required={task.required == 'YES'}
			                    min={task.answer ? task.answer.split(";")[0] : ''}
			                    style={{ width: 240 }}
			                />
			            </Form.Group>
					}
					{ task.type == 'TIME' &&
						<Form.Group controlId="answer">
			                <Form.Control
			                    type="time"
			                    name="answer"
			                    value={task.answer || ''}
			                    onChange={(e) => handleAnswerChange(e, task)}
			                    required={task.required == 'YES'}
			                    style={{ width: 240 }}
			                />
			            </Form.Group>
					}
					{ task.type == 'DATE_TIME' &&
						<Form.Group controlId="answer">
			                <Form.Control
			                    type="date"
			                    name="date"
			                    value={task.answer ? task.answer.split(" ")[0] : ''}
			                    onChange={(e) => handleAnswerChange(e, task)}
			                    required={task.required == 'YES'}
			                    style={{ marginBottom: 2, width: 240 }}
			                />
			                <Form.Control
			                    type="time"
			                    name="time"
			                    value={task.answer ? task.answer.split(" ")[1] : ''}
			                    onChange={(e) => handleAnswerChange(e, task)}
			                    required={task.required == 'YES'}
			                    style={{ width: 240 }}
			                />
			            </Form.Group>
					}
					{ task.type == 'CONTACT_PERSONS' &&
						<>
							{ suggestionLists.filter(suggestionList => suggestionList.id == task.options).map(suggestionList => {
	                            return <table key={"table-" + task.id} className="table">
				                    <thead>
				                        <tr>
				                            <th></th>
					                        { suggestionList.params.columns.split(";").map(column => {
					                            return <th key={"table-" + task.id + "-" + column}>
					                                {column}
					                            </th>
					                        })}
				                        </tr>
				                    </thead>
				                    <tbody>
				                        { suggestionList.suggestions.map(suggestion => {
				                            return <tr key={"table-" + task.id + "-" + suggestion.id}>
				                                <td>
				                                    <Form.Check
							                            id={task.id + '-' + suggestion.id + '-check'}
							                            type="checkbox"
							                            name={suggestion.id}
							                            value={suggestion.text}
							                            checked={task.answer && task.answer.split('\n').includes(suggestion.text)}
							                            onChange={(e) => handleAnswerChange(e, task)}
							                            required={task.required == 'YES' && !task.answer}
							                        />
				                                </td>
				                                { suggestion.text.split(";").map((value, index) => {
				                                    return <td key={"table-" + task.id + "-" + suggestion.id + "-" + index}>
				                                        {value}
				                                    </td>
				                                })}
				                            </tr>
				                        })}
				                    </tbody>
				                </table>
	                        })}
	                        { task.params && task.params.addContactPersonEnabled &&
		                        <Button variant="outline-primary" onClick={() => addContactPerson(task)}>
						            {t('documentation.addcontactperson')}
						        </Button>
					        }
                        </>
					}
					{ task.type == 'PREDEFINED' &&
						<>
							{ loadingPredefinedAnswers &&
								<Spinner animation="border" variant="secondary" role="status" size="sm"/>
							}
							{ !loadingPredefinedAnswers &&
								<Form.Control
									type="text"
					                name="text"
					                value={task.answer || ''}
					                onChange={e => handleAnswerChange(e, task)}
					                required={task.required == 'YES'}
					                maxLength="2000"
					                disabled={!task.params.editable}
					            />
							}
						</>
					}
					{ ['MAP_MARKER', 'MAP_MULTIPLE_MARKERS', 'MAP_POLYGON'].includes(task.type)  &&
						<MapTask task={task} onChange={handleAnswerChange}/>
					}
	                { documentation.tasks.filter(child => child.parent == task.id).map(child => {
						return getTaskCard(child)
					})}
	            </Card.Body>
            }
        </Card>
    }

    const getTaskIcon = (task) => {
	    switch (task.type) {
			case 'PHOTO':
				return <FontAwesomeIcon icon={faCamera}/>
			case 'FILE':
				return <FontAwesomeIcon icon={faPaperclip}/>
			case 'DRAWING':
				return <FontAwesomeIcon icon={faPaintbrush}/>
			case 'TEXT':
			case 'STATIC_TEXT':
				return <FontAwesomeIcon icon={faFont}/>
			case 'HEADER':
				return <FontAwesomeIcon icon={faHeading}/>
			case 'INTEGER':
			case 'DECIMAL':
				return <FontAwesomeIcon icon={faHashtag}/>
			case 'CHECKBOX':
			case 'SINGLE_CHOICE':
			case 'MULTI_CHOICE':
			case 'SINGLE_CHOICE_SUGGESTION':
			case 'MULTI_CHOICE_SUGGESTION':
				return <FontAwesomeIcon icon={faListCheck}/>
			case 'GROUP':
				return <FontAwesomeIcon icon={faFolder}/>
			case 'PREDEFINED':
				return <FontAwesomeIcon icon={faGear}/>
			case 'DATE':
			case 'DATE_RANGE':
			case 'DATE_TIME':
				return <FontAwesomeIcon icon={faCalendar}/>
			case 'TIME':
				return <FontAwesomeIcon icon={faClock}/>
			case 'CONTACT_PERSONS':
				return <FontAwesomeIcon icon={faUsers}/>
			case 'ZEBRA_SCANNER':
				return <FontAwesomeIcon icon={faBarcode}/>
			case 'MAP_MARKER':
			case 'MAP_MULTIPLE_MARKERS':
			case 'MAP_POLYGON':
				return <FontAwesomeIcon icon={faMap}/>
		}
		return <FontAwesomeIcon icon={faCamera}/>
    }

    const filterTemplates = () => {
        var filteredTemplates = templates.filter(template => {
            return template.customerId == selectedLicense.customerId
        })
        filteredTemplates = filteredTemplates.filter(template => {
            var noLicenses = template.templateLicenses.length == 0
            var someLicense = template.templateLicenses.some(templateLicense => templateLicense.license == selectedLicense.id)
            return noLicenses || someLicense
        })
        if (selectedLicense.reverseDocumentationCreation) {
            var filteredLists = suggestionLists.filter(suggestionList => suggestionList.suggestions.some(suggestion => suggestion.text == name))
            filteredTemplates = filteredTemplates.filter(template => template.suggestionList && filteredLists.some(list => list.id == template.suggestionList))
        }
        filteredTemplates.sort((a, b) => a.name.localeCompare(b.name))
        filteredTemplates.sort((a, b) => a.position - b.position)
        return filteredTemplates
    }

    const getSuggestions = () => {
        var suggestions = []
        if (!selectedLicense.reverseDocumentationCreation) {
            var suggestionList = suggestionLists.find(suggestionList => suggestionList.id == selectedTemplate.suggestionList)
            if (suggestionList) {
                suggestionList.suggestions.forEach(suggestion => {
	                if (!suggestions.some(s => s.text == suggestion.text)) {
	                    suggestions.push(suggestion)
	                }
	            })
            }
        } else {
            suggestionLists.forEach(suggestionList => {
                var validSuggestionList = true

                if (suggestionList.type != 'DOCUMENTATION_NAMES') {
                    validSuggestionList = false
                } else if (suggestionList.suggestionListLicenses && suggestionList.suggestionListLicenses.length > 0) {
					validSuggestionList = suggestionList.suggestionListLicenses.some(suggestionListLicense => suggestionListLicense.license == selectedLicense.id)
                } else {
                    validSuggestionList = suggestionList.customerId == selectedLicense.customerId
                }

                if (validSuggestionList) {
		            suggestionList.suggestions.forEach(suggestion => {
		                if (!suggestions.some(s => s.text == suggestion.text)) {
		                    suggestions.push(suggestion)
		                }
		            })
	            }
	        })
        }
        return suggestions
    }

    const handleSuggestionChange = suggestion => {
        console.log('handleSuggestionChange')
        setName(suggestion.text)

        if (selectedTemplate.locationEnabled && suggestion.lat != 1000 && suggestion.lng != 1000) {
            console.log(suggestion)
            setDocumentation( prevState => ({
		        ...prevState,
		        lat: suggestion.lat,
		        lng: suggestion.lng
			}))
        }

		if (documentation.tasks.some(task => task.type == 'PREDEFINED')) {
			setLoadingPredefinedAnswers(true)
			documentationService.getPredefinedAnswers(selectedTemplate.id, suggestion.text).then(result => {
				documentation.tasks.forEach(task => {
					if (task.type == 'PREDEFINED') {
						Object.entries(result).map(entry => {
							if (entry[0] == task.options) {
								task.answer = entry[1]
							}
						})
						task.events = task.events.filter(event => event.type != 'UPDATED')
					}
				})

				setDocumentation( prevState => ({
			        ...prevState,
			        tasks: prevState.tasks
				}))

				setLoadingPredefinedAnswers(false)
			})
		}
    }

    const getNameInput = () => {
		if (!selectedLicense.reverseDocumentationCreation) {
			if (selectedTemplate) {
				if (selectedTemplate.suggestionList) {
					if (selectedTemplate.onlySuggestionsAllowed) {
						return <Select
		                    placeholder={t('documentation.columns.name')}
		                    isLoading={suggestionLists.length === 0}
		                    options={getSuggestions()}
		                    getOptionLabel={ suggestion => suggestion.text }
		                    getOptionValue={ suggestion => suggestion.text }
		                    isMulti={false}
		                    closeMenuOnSelect={true}
		                    onChange={handleSuggestionChange}
		                />
					} else {
						return <>
							<Form.Control
								list="nameSuggestions"
				                placeholder={t('documentation.columns.name')}
				                name="name"
				                value={name}
				                onChange={handleNameChange}
				                required
				            />
				            <datalist id="nameSuggestions">
							    { getSuggestions().map(suggestion =>
							        <option key={suggestion.id} value={suggestion.text}/>
							    )}
							</datalist>
			            </>
					}
				} else {
					return <Form.Control
		                placeholder={t('documentation.columns.name')}
		                name="name"
		                value={name}
		                onChange={handleNameChange}
		                required
		            />
				}
			}
		} else {
			return <Select
                placeholder={t('documentation.columns.name')}
                isLoading={suggestionLists.length === 0}
                options={getSuggestions()}
                getOptionLabel={ suggestion => suggestion.text }
                getOptionValue={ suggestion => suggestion.text }
                isMulti={false}
                closeMenuOnSelect={true}
                onChange={suggestion => setName(suggestion.text)}
            />
		}
		return <></>
    }

    const checkPreconditions = task => {
        if (task.preconditions.length == 0) {
            return true
        }

        var result = true
        task.preconditions.forEach(precondition => {
            switch (precondition.type) {
                case 'TASK_ANSWER':
                    var taskId = precondition.params.TASK_ID
                    var answer = precondition.params.ANSWER
                    var operator = precondition.params.OPERATOR
                    var task = documentation.tasks.find(task => task.id == taskId)
                    if (task) {
                        if (operator == 'EQUALS') {
                            if (task.answer != answer) {
                                result = false
                            }
                        } else if (operator == 'NOT_EQUALS') {
                            if (task.answer == answer) {
                                result = false
                            }
                        }
                    }
                    break
                case 'TASK_PHOTOS_TAKEN':
					var taskId = precondition.params.TASK_ID
					if (!photos.some(photo => photo.documentationTask == taskId)) {
						result = false
					}
                    break
                case 'TASK_NO_PHOTOS_TAKEN':
					var taskId = precondition.params.TASK_ID
					if (photos.some(photo => photo.documentationTask == taskId)) {
						result = false
					}
                    break
                case 'PLATFORM':
					var platform = precondition.params.PLATFORM
					if (platform != 'APP') {
						result = false
					}
                    break
                case 'TASK_FINISHED':
                    var taskId = precondition.params.TASK_ID
                    var task = documentation.tasks.find(task => task.id == taskId)
                    if (task) {
                        if (task.type == 'PHOTO' || task.type == 'DRAWING') {
                            if (!photos.some(photo => photo.documentationTask == taskId)) {
								result = false
							}
                        } else if (task.type == 'FILE') {
                            if (!files.some(file => file.documentationTask == taskId)) {
								result = false
							}
                        } else {
                            if (!task.answer) {
                                result = false
                            }
                        }
                    }
                    break
                case 'TASK_UNFINISHED':
                    var taskId = precondition.params.TASK_ID
                    var task = documentation.tasks.find(task => task.id == taskId)
                    if (task) {
                        if (task.type == 'PHOTO' || task.type == 'DRAWING') {
                            if (photos.some(photo => photo.documentationTask == taskId)) {
								result = false
							}
                        } else if (task.type == 'FILE') {
                            if (files.some(file => file.documentationTask == taskId)) {
								result = false
							}
                        } else {
                            if (task.answer) {
                                result = false
                            }
                        }
                    }
                    break
                case 'TASK_ANSWER_INCLUDES':
                    var taskId = precondition.params.TASK_ID
                    var answer = precondition.params.ANSWER
                    var task = documentation.tasks.find(task => task.id == taskId)
                    if (task) {
                        var split = task.answer.split(';')
                        if (!split.includes(answer)) {
                            result = false
                        }
                    }
                    break
            }
        })

        return result
    }

    const addContactPerson = task => {
        console.log('addContactPerson')

        var suggestionList = suggestionLists.find(suggestionList => suggestionList.id == task.options)

        console.log(suggestionList)

        if (suggestionList) {
	        var addContactPersonValues = suggestionList.params.columns.split(";").map(column => '')

	        setAddContactPersonSuggestionList(suggestionList)
	        setAddContactPersonValues(addContactPersonValues)
	        setShowAddContactPersonModal(true)
        }
    }

    const handleAddContactPersonChange = (e, index) => {
        console.log('handleAddContactPersonChange')

        var newAddContactPersonValues = [...addContactPersonValues]
        newAddContactPersonValues[index] = e.target.value

        setAddContactPersonValues(newAddContactPersonValues)
    }

    const submitAddContactPerson = () => {
        var suggestion = {
            id: uuidv4(),
            text: addContactPersonValues.join(';')
        }

        var existingSuggestion = addContactPersonSuggestionList.suggestions.find(otherSuggestion => otherSuggestion.text == suggestion.text)

        if (!existingSuggestion) {
	        addContactPersonSuggestionList.suggestions.push(suggestion)

	        var newSuggestionLists = [...suggestionLists]
	        setSuggestionLists(newSuggestionLists)

	        setAddContactPersonSuggestionList(null)
	        setAddContactPersonValues([])
	        setShowAddContactPersonModal(false)
        }
    }

    const onLoad = map => {
        console.log('onLoad')

        setMap(map)

        map.setZoom(10)

        if (documentation) {
            map.setCenter({ lat: documentation.lat, lng: documentation.lng })
        }
	}

	const onUnmount = e => {
	    setMap(null)
	}

	const onMapChange = e => {
		console.log('onMapChange')
		console.log(e)

		setDocumentation( prevState => ({
	        ...prevState,
	        lat: e.lat,
	        lng: e.lng
		}))

		if (map) {
			map.setCenter({ lat: documentation.lat, lng: documentation.lng })
		}
	}

	const showSaveAsDraftButton = () => {
		if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
			if (selectedTemplate) {
				var customer = customers.find(customer => customer.id == selectedTemplate.customerId)
				if (customer) {
					return customer.documentationStatuses.includes('DRAFT')
				}
			}
			return false
		}
		return authService.hasDocumentationStatuses(['DRAFT'])
	}

    return (
        <>
	        <Form id="data-form" noValidate onSubmit={handleSubmit} validated={validated}>
	            <Row>
	                <Col sm="4" style={{position: 'fixed', top: 70}}>
						{ licenses.length > 1 &&
							<Form.Group controlId="license">
			                    <Form.Label>
				                    {t('documentation.columns.license')}
				                </Form.Label>
				                <Select
				                    placeholder="Välj licens"
				                    isLoading={licenses.length === 0}
				                    options={licenses}
				                    value={selectedLicense}
				                    getOptionLabel={ license => {
				                        return license.name ? license.name + ' (' + license.licenseCode + ')' : license.licenseCode
				                    }}
				                    getOptionValue={ license => license.id }
				                    isMulti={false}
				                    closeMenuOnSelect={true}
				                    onChange={handleLicenseChange}
				                />
		                    </Form.Group>
		                }
		                { selectedLicense &&
			                <>
			                    { !selectedLicense.reverseDocumentationCreation &&
			                        <>
										<Form.Group controlId="template">
						                    <Form.Label>
							                    {t('documentation.columns.template')}
							                </Form.Label>
							                <Select
							                    placeholder={t('template.choosetemplate')}
							                    isLoading={templates.length === 0}
							                    options={filterTemplates()}
							                    value={selectedTemplate}
							                    getOptionLabel={ template => {
							                        if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
							                            return template.name + ' (' + template.customerName + ')'
							                        }
							                        return template.name
							                    }}
							                    getOptionValue={ template => template.id }
							                    isMulti={false}
							                    closeMenuOnSelect={true}
							                    onChange={handleTemplateChange}
							                />
					                    </Form.Group>
							            { selectedTemplate &&
						                    <Form.Group controlId="name">
							                    <Form.Label>
								                    {t('documentation.columns.name')} *
								                </Form.Label>
						                        {getNameInput()}
						                    </Form.Group>
							            }
					                </>
			                    }
			                    { selectedLicense.reverseDocumentationCreation &&
			                        <>
					                    <Form.Group controlId="name">
						                    <Form.Label>
							                    {t('documentation.columns.name')} *
							                </Form.Label>
					                        {getNameInput()}
					                    </Form.Group>
							            { name &&
											<Form.Group controlId="template">
							                    <Form.Label>
								                    {t('documentation.columns.template')}
								                </Form.Label>
								                <Select
								                    placeholder={t('template.choosetemplate')}
								                    isLoading={templates.length === 0}
								                    options={filterTemplates()}
								                    value={selectedTemplate}
								                    getOptionLabel={ template => {
								                        if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
								                            return template.name + ' (' + template.customerName + ')'
								                        }
								                        return template.name
								                    }}
								                    getOptionValue={ template => template.id }
								                    isMulti={false}
								                    closeMenuOnSelect={true}
								                    onChange={handleTemplateChange}
								                />
						                    </Form.Group>
							            }
					                </>
			                    }
			                </>
			            }
			            { selectedTemplate && selectedTemplate.locationEnabled && documentation &&
			                <Form.Group controlId="latLng">
			                    <Form.Label>
				                    {t('documentation.columns.location')} { selectedTemplate.locationRequired ? '*' : '' }
				                </Form.Label>
				                { documentation.lat && documentation.lng &&
				                    <GoogleMap
				                        center={{ lat: documentation.lat, lng: documentation.lng }}
				                        mapContainerStyle={mapContainerStyle}
								        onLoad={onLoad}
								        onUnmount={onUnmount}
								        options={{ minZoom: 3, zoomControl: true }}>
								        <Marker
						                    position={{lat: documentation.lat, lng: documentation.lng}}
						                />
									</GoogleMap>
				                }
				                <div>
			                        <MapButton lat={documentation.lat} lng={documentation.lng} onChange={onMapChange}/>
			                    </div>
			                </Form.Group>
			            }
			            <Button variant="secondary" onClick={() => history.goBack()}>
				            {t('crudtable.cancel')}
				        </Button>
				        { selectedLicense && documentation && name && showSaveAsDraftButton() &&
				            <>
				                &nbsp;
				                { !saving &&
				                    <Button form="data-form" name="draft" value="draft" type="submit" variant="outline-primary">
				                        {t('documentation.savedraft')}
				                    </Button>
				                }
				                { saving && documentationStatus != 'draft' &&
				                    <Button form="data-form" variant="outline-primary" disabled>
				                        {t('documentation.savedraft')}
				                    </Button>
				                }
				                { saving && documentationStatus == 'draft' &&
				                    <Button variant="outline-primary">
				                        {t('crudtable.saving')}
				                        &nbsp;
							            <Spinner animation="border" role="status" size="sm">
											<span className="sr-only">{t('crudtable.saving')}...</span>
										</Spinner>
				                    </Button>
				                }
				            </>
				        }
				        { documentation && name &&
				            <>
				                &nbsp;
				                { !saving &&
				                    <Button form="data-form" name="completed" value="completed" type="submit" variant="primary">
				                        {t('documentation.complete.button')}
				                    </Button>
				                }
				                { saving && documentationStatus != 'completed' &&
				                    <Button form="data-form" variant="primary" disabled>
				                        {t('documentation.complete.button')}
				                    </Button>
				                }
				                { saving && documentationStatus == 'completed' &&
				                    <Button variant="primary">
				                        {t('crudtable.saving')}
				                        &nbsp;
							            <Spinner animation="border" role="status" size="sm">
											<span className="sr-only">Loading...</span>
										</Spinner>
				                    </Button>
				                }
				            </>
				        }
				        { selectedLicense && documentation && name && selectedLicense.pauseDocumentations &&
				            <>
				                &nbsp;
				                { !saving &&
				                    <Button form="data-form" name="paused" value="paused" type="submit" variant="primary">
				                        {t('documentation.pause')}
				                    </Button>
				                }
				                { saving && documentationStatus != 'paused' &&
				                    <Button form="data-form" variant="primary" disabled>
				                        {t('documentation.pause')}
				                    </Button>
				                }
				                { saving && documentationStatus == 'paused' &&
				                    <Button variant="primary">
				                        {t('crudtable.saving')}
				                        &nbsp;
								            <Spinner animation="border" role="status" size="sm">
												<span className="sr-only">Loading...</span>
											</Spinner>
				                    </Button>
				                }
				            </>
				        }
	                </Col>
	                <Col sm={{span: 8, offset: 4}}>
	                    { documentation &&
	                        <>
								<Form.Label>
									{t('documentation.columns.tasks')}
								</Form.Label>
								{ documentation.tasks.filter(task => !task.parent).map(task => {
									return getTaskCard(task)
								})}
							</>
						}
					</Col>
	            </Row>
		        <ScrollUpButton/>
	        </Form>
	        <Modal
				style={{overflow: 'scroll'}}
				size="md"
				show={showProgressModal}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={() => setShowProgressModal(false)}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('crudtable.saving')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<table className="table">
						<tbody>
							<tr>
								<td>
									{t('documentation.form.savingdocumentation')}
								</td>
								<td>
									{ documentationProgress == 0 &&
										<Spinner animation="border" role="status" size="sm">
											<span className="sr-only">Loading...</span>
										</Spinner>
									}
									{ documentationProgress == 1 &&
										<FontAwesomeIcon icon={faCheck} style={{color: '#1f6e43'}}/>
									}
								</td>
							</tr>
							{ photos.length > 0 &&
								<tr>
									<td>
										{t('documentation.form.savingphotos')}
									</td>
									<td>
										{ photoProgress < photos.length &&
											<>
												{photoProgress} / {photos.length}
											</>
										}
										{ photoProgress == photos.length &&
											<FontAwesomeIcon icon={faCheck} style={{color: '#1f6e43'}}/>
										}
									</td>
								</tr>
							}
							{ files.length > 0 &&
								<tr>
									<td>
										{t('documentation.form.savingfiles')}
									</td>
									<td>
										{ photoProgress < photos.length &&
											<>
												{fileProgress} / {files.length}
											</>
										}
										{ photoProgress == photos.length &&
											<FontAwesomeIcon icon={faCheck} style={{color: '#1f6e43'}}/>
										}
									</td>
								</tr>
							}
						</tbody>
					</table>
				</Modal.Body>
			</Modal>
	        <Modal
				style={{overflow: 'scroll'}}
				size="md"
				show={showAddContactPersonModal}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={() => setShowAddContactPersonModal(false)}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('documentation.addcontactperson')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{ addContactPersonSuggestionList &&
						<>
							{ addContactPersonSuggestionList.params.columns.split(";").map((column, index) => {
								return <div key={'addContactPersonModal-' + column}>
									<Form.Label style={{marginBottom: 2}}>
										{column}
										{ addContactPersonSuggestionList.params.requiredColumns.split(";").includes(column) &&
											<span> *</span>
										}
									</Form.Label>
									<Form.Control
						                placeholder={column}
						                name={column}
						                value={addContactPersonValues[index]}
						                onChange={e => handleAddContactPersonChange(e, index)}
						                style={{marginBottom: 10}}
						            />
								</div>
							})}
						</>
					}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="outline-secondary" onClick={() => setShowAddContactPersonModal(false)}>
						{t('crudtable.cancel')}
					</Button>
					<Button variant="primary" onClick={() => submitAddContactPerson()}>
						{t('crudtable.add')}
					</Button>
				</Modal.Footer>
			</Modal>
        </>
    )
}

export default DocumentationForm